export default {
  listViewShortcuts: state =>
    state.savedViews.filter(savedView => savedView.shortcuts.listView === true)
};
